import { render, staticRenderFns } from "./default.vue?vue&type=template&id=2292d00a"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MaintenanceBanner: require('/app/components/maintenanceBanner.vue').default,Header: require('/app/components/header.vue').default,Sidebar: require('/app/components/sidebar.vue').default,BlockUnwind: require('/app/components/block/unwind.vue').default,Footer: require('/app/components/footer.vue').default,Back: require('/app/components/back.vue').default,ToastGeneral: require('/app/components/toastGeneral.vue').default})
